<template>
  <div class="modal-coupon-plan-card-parts">
    <div class="modal-coupon-plan-card-parts__card">
      <div class="modal-coupon-plan-card-parts__main">
        <p class="modal-coupon-plan-card-parts__title">
          {{ plan.couponData.couponName[$i18n.locale] }}
        </p>
        <p class="modal-coupon-plan-card-parts__subtitle">
          {{ plan.couponData.title[$i18n.locale] }}
        </p>
        <p class="modal-coupon-plan-card-parts__description">
          {{ plan.couponData.description[$i18n.locale] }}
        </p>
        <p class="modal-coupon-plan-card-parts__period">
          <span>{{ plan.couponData.couponApplicationPeriodText }}</span>
        </p>
      </div>
      <div class="modal-coupon-plan-card-parts__side">
        <p class="modal-coupon-plan-card-parts__price">
          <span>{{ priceJpy }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from '@vue/composition-api'
import ContractPlanDocument from '@/store/stores/collectionModule/documents/plan/ContractPlanDocument'
import I18n from '@/locales/I18n'

export default defineComponent({
  name: 'ModalCouponPlanCardParts',
  props: {
    /**
     * 表示するプラン
     */
    plan: {
      type: Object as PropType<ContractPlanDocument | null>,
      default: () => ({}),
    },
  },
  setup(props) {
    /** 金額の単位（現状は円のみ） */
    const planPriceUnit = I18n.tc('SignupPage.SelectPlanPage.plan.priceUnit')

    /** 表示する金額（円） */
    const priceJpy = computed(() => `${props.plan?.price?.JPY.toLocaleString()}${planPriceUnit}`)

    return {
      priceJpy,
    }
  },
})
</script>

<style scoped lang="scss">
.modal-coupon-plan-card-parts {
  &__card {
    display: flex;
    gap: 6px;
    justify-content: space-between;
    padding: 10px;
    font-family: $fontSignup;
    border: 1px solid rgba($black, 0.1);
    border-radius: 6px;
  }

  &__main {
    text-align: left;
  }

  &__title {
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.02em;
    color: $black;
    line-height: 1.5;
  }

  &__subtitle {
    margin-top: 4px;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.02em;
    color: $black90;
    line-height: 1.66;
  }

  &__description {
    margin-top: 4px;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.02em;
    color: $gray75;
    line-height: 1.45;
    white-space: pre-line;
  }

  &__period {
    margin-top: 4px;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.02em;
    color: $gray75;
    line-height: 1.45;
  }

  &__price {
    display: flex;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.02em;
    color: $black;
    line-height: 1.5;
    text-align: right;
    white-space: nowrap;
  }
}
</style>
